//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Autocomplete from 'vue2-autocomplete-js';
import Joi from "joi";
const schema = Joi.object().keys({
    username: Joi.string().regex(/^[a-zA-Z0-9_]*$/).min(3).max(13).required(),
    password: Joi.string().min(6).required(),
  });
import UMUM from  '../../library/umum.js'


export default {
  data() {
    return {
      dense:true,
      token : localStorage.token,
      

        form : {
            id : '',
            uraian : '',
            createdAt : '',
        },
        options:[
          {value:'semua', uraian:'Semua'},
          {value:'provinsi', uraian:'Provinsi'},
          {value:'kabupaten', uraian:'Kabupaten'},
          {value:'kecamatan', uraian:'Kecamatan'},
          {value:'desa', uraian:'Desa / Kelurahan'},
          {value:'masyarakat', uraian:'Masyarakat'}
        ],
          // 'Semua', 'Provinsi', 'Kabupaten', 'Kecamatan', 'Desa / Kelurahan'

        dataku: {
            id : '',
            level : '',
            kelas : '',
            nama : '',
            username : "",
            password : "",
            confirmPassword: "",
            email: "",
            hp: "",

            m_provinsi:"",
            m_kabupaten:"",
            m_kecamatan:"",
            m_desa_kelurahan:"",
        },

        wilayah: {
          uraian_provinsi:'',
          uraian_kabupaten:'',
          uraian_kecamatan:'',
          uraian_desa_kelurahan:'',
        },

        list_data : [],
        list_level : [],
     
         errorMessage: '',

        page_limit : 8,
        page_first: 1,
        page_last: 0,
        cari_value: "",
        cari_byLevel: "Semua",
        cek_load_data : true,


        mdl_add: false,
        mdl_edit: false,
        mdl_pass: false,
        mdl_hapus : false,
        btn_add: false,
    }
  },
  methods: {


    getView: function() {
 
        fetch(this.$store.state.url.URL_REGISTRASI + "view_contoh", {
            method: "POST",
            headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify({
                data_ke: this.page_first,
                page_limit : this.page_limit,
                cari_value: this.cari_value,
                cari_byLevel: this.cari_byLevel
            })
        })
            .then(res => res.json())
            .then(res_data => {
                this.list_data = res_data.data;
                this.page_last = res_data.jmlData;
                // this.$store.commit("hideLoading");
                console.log(res_data);
        });
    },

    addData: function() {
      this.errorMessage = "";
        if (this.validUser()) {
            // Jika user sdh valid lakukan pengiriman data ke server
            const body = {
              username: this.dataku.username,
              password: this.dataku.password
            };
            this.signingUp = true;
            fetch(this.$store.state.url.URL_REGISTRASI+'signup', {
                method: "POST",
                body: JSON.stringify(this.dataku),
                headers: {
                    "content-type": "application/json",
                    authorization: "kikensbatara " + localStorage.token
                }
            }).then((response) => {
                this.signingUp = false;
                if (response.ok) {
                    this.Notify('Sukses Menambah Data', 'primary', 'check_circle_outline');
                    this.getView();
                    // this.$router.push('/login');
                    // return response.json();
                }
                else{
                  return response.json().then(error => {
                    throw new Error(error.message);
                  });

                }
            })
            .catch((error) => {
              setTimeout(() => {
                this.signingUp = false;
                this.errorMessage = error.message;
              }, 1000);
            });
        }else{
          console.log("tidak valid");

        }

    },

    editData: function() {
        fetch(this.$store.state.url.URL_REGISTRASI + "editData", {
            method: "POST",
            headers: {
                'content-type' : 'application/json',
                authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify({
                id : this.dataku.id,
                level : this.dataku.level,
                nama : this.dataku.nama,
                username : this.dataku.username,
                email: this.dataku.email,
                hp: this.dataku.hp
            })
        })
        .then(res => res.json())
        .then(res_data => {

            if (res_data.success) {
              // Update localStorage 
              this.$q.notify({
                message: res_data.message || 'data berhasil diperbarui!',
                position: 'top',
                color: 'positive',
                icon: 'check_circle',
                timeout: 2000
              })

              this.showEditProfileModal = false
              this.getView()
            } else {
              this.$q.notify({
                message: res_data.message || 'Gagal memperbarui data',
                position: 'top',
                color: 'negative',
                icon: 'error',
                timeout: 2000
              })
            }          
            // this.Notify('Sukses Merubah Data', 'warning', 'check_circle_outline');
            // this.getView();
        })
        .catch(error => {
            this.uploading = false
            console.error('Error:', error)
            this.$q.notify({
              message: 'Terjadi kesalahan: ' + error.message,
              position: 'top',
              color: 'negative',
              icon: 'error',
              timeout: 2000
            })
          })
    },

    editPass: function() {
        fetch(this.$store.state.url.URL_REGISTRASI + "editPassword", {
            method: "POST",
            headers: {
                'content-type' : 'application/json',
                authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify({
                id : this.dataku.id,
                username : this.dataku.username,
                password : this.dataku.password
                 
            })
        }).then(res_data => {
            this.Notify('Sukses Merubah Password', 'warning', 'check_circle_outline');
            this.getView();
        });
    },

    removeData: function(idnya) {
        fetch(this.$store.state.url.URL_REGISTRASI + "removeData", {
            method: "POST",
            headers: {
                "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify({
                id: this.dataku.id,
            })
        }).then(res_data => {
            this.getView();
            this.Notify('Sukses Merubah Data', 'warning', 'check_circle_outline');
        });
    },


    getLevel: function() {
        fetch(this.$store.state.url.URL_LEVEL_USERS + "list", {
            method: "GET",
            headers: {
                "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
            },
          
        })
            .then(res => res.json())
            .then(res_data => {
                this.list_level = res_data;
                // this.$store.commit("hideLoading");
                console.log(res_data);
        });
    },

    validUser : function(){
      if (this.dataku.password !== this.dataku.confirmPassword) {
          this.errorMessage = "Password dan Confirm Password harus sama. !";
          return false;
      }
      // Memulai proses validasi melalui skema Joi yang sebelumnya dibuat
      // req.body merupakan data yang di kirim oleh client dan schema merupakan skema joi yg di buat sebelumnya
      const body = {
              username: this.dataku.username,
              password: this.dataku.password
      };
      const result = Joi.validate(body, schema);

      if (result.error === null) {
          return true;
      }
      if (result.error.message.includes("username")) {
          // jika pesan error yang dihasilkan mengandung char "username" maka
          this.errorMessage = "Username tidak valid (Min : 6 dan Max : 14 Karakter)";
      } else {
          this.errorMessage = "Password tidak valid (Min : 6 Karakter)";
        //   console.log(result.error);

      }
      return false;
    },

    selectData : function(data){
        console.log(data);
        this.dataku.id = data.id;
        this.dataku.nama = data.nama;
        this.dataku.kelas = data.kelas;
        this.dataku.level = data.level;
        this.dataku.username = data.username;
        this.dataku.email = data.email;
        this.dataku.hp = data.hp;
        
        this.dataku.m_provinsi = data.provinsi;
        this.dataku.m_kabupaten = data.kabupaten;
        this.dataku.m_kecamatan = data.kecamatan;
        this.dataku.m_desa_kelurahan = data.desa_kelurahan;

        if (data.kelas == 'desa'){
          this.wilayah = {
              uraian_provinsi       : data.m_provinsi.uraian,
              kd_provinsi           : data.m_provinsi.kd_provinsi,
              uraian_kabupaten      : data.m_kabupaten.uraian,
              kd_kabupaten          : data.m_kabupaten.kd_kabupaten,
              uraian_kecamatan      : data.m_kecamatan.uraian,
              kd_kecamatan          : data.m_kecamatan.kd_kecamatan,
              uraian_desa_kelurahan : data.m_desa_kelurahan.uraian,
              kd_desa_kelurahan     : data.m_desa_kelurahan.kd_desa_kelurahan,
            }; 
        }
        else if (data.kelas == 'kecamatan'){
          this.wilayah = {
              uraian_provinsi       : data.m_provinsi.uraian,
              kd_provinsi           : data.m_provinsi.kd_provinsi,
              uraian_kabupaten      : data.m_kabupaten.uraian,
              kd_kabupaten          : data.m_kabupaten.kd_kabupaten,
              uraian_kecamatan      : data.m_kecamatan.uraian,
              kd_kecamatan          : data.m_kecamatan.kd_kecamatan, 
            }; 
        }
        else if (data.kelas == 'kabupaten'){
          this.wilayah = {
              uraian_provinsi       : data.m_provinsi.uraian,
              kd_provinsi           : data.m_provinsi.kd_provinsi,
              uraian_kabupaten      : data.m_kabupaten.uraian,
              kd_kabupaten          : data.m_kabupaten.kd_kabupaten, 
            }; 
        }

 

        
    },
    // ====================================== filter autocomplete  
      renderChildProv(data) {
          return `
          <span><b>${data.kd_provinsi}</b></span>
          <span style='font-size:80%'>${data.uraian}</span>
          `
      },    
      renderChildKab(data) {
          return `
          <span><b>${data.kd_kabupaten}</b></span>
          <span style='font-size:80%'>${data.uraian}</span>
          `
      },    
      renderChildKec(data) {
          return `
          <span><b>${data.kd_kecamatan}</b></span>
          <span style='font-size:80%'>${data.uraian}</span>
          `
      },    
      renderChild_des_kel(data) {
          return `
          <span><b>${data.kd_desa_kelurahan}</b></span>
          <span style='font-size:80%'>${data.uraian}</span>
          `
      },    

      get_auto(data){
        // console.log(data.kd_provinsi);  
        this.dataku.m_provinsi    = data.m_provinsi   
      },        
      get_auto_kab(data){  
        this.dataku.m_kabupaten   = data.m_kabupaten  
        // console.log(data.kd_kabupaten); 
      },        
      get_auto_kec(data){  
        this.dataku.m_kecamatan   = data.m_kecamatan  
        // console.log(data.kd_kecamatan); 
      },        
      get_auto_des_kel(data){  
        this.dataku.m_desa_kelurahan = data.m_desa_kelurahan  
        // console.log(data.kd_desa_kelurahan); 
      },
    // ====================================== filter autocomplete    



    // ====================================== PAGINATE ====================================
        Notify : function(message, positive, icon){
          this.$q.notify({
            message: message,
            color: positive,
            icon: icon,
            position : 'top',
            timeout: 500,
          })
        },

        CariData : function(){
            // this.page_first = 1;
            this.getView();
        },

        indexing : function(index){
            var idx = ((this.page_first-1)*this.page_limit)+index
            return idx
        }




    // ====================================== PAGINATE ====================================







  },

  mounted () {
    // this.getView();
    this.CariData()
    this.getLevel();
  },
}
